let hostname = window.location.hostname;
let whiteLabelConfig;
if (window.webconfig) {
    whiteLabelConfig = window.webconfig.find((config) => config.domain === hostname);
}

whiteLabelConfig = {
    domain: 'https://virtuowltutoring.com/',
    appname: 'VirtuOwl',
    title: 'VirtuOwl',
    whitelabeled: true,
    logoType: 'Image',
    // logo: 'https://virtuowl-dev.s3.amazonaws.com/virtuOwl_logo.png',
    // ins_logo: 'https://virtuowl-dev.s3.amazonaws.com/virtuowl_voim.png',
    // ins_branch_admin_logo: 'https://virtuowl-dev.s3.amazonaws.com/SCHOOL_ADMIN_LOGO.png',
    // ghrr_logo: 'https://virtuowl-dev.s3.amazonaws.com/GHRR.png',
    // videoLogoIcon: 'https://virtuowl-dev.s3.amazonaws.com/InTeleTutor_Logo_Mascot_A.svg',
    favType: 'image/ico',
};

module.exports = whiteLabelConfig;
